import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import App from "./App";

// Silence the benign "ResizeObserver loop completed with undelivered notifications"
// dev-overlay noise that Radix Popover/Select can trigger inside animated dialogs.
if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => {
    if (e?.message?.includes("ResizeObserver loop")) {
      e.stopImmediatePropagation();
    }
  });
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
